import { RECEIVE_LOGIN } from "../actions/auth";

export const init = {
  uid: "",
  displayName: "",
  email: "",
  date: "",
  photoURL: "",
  isLogin: false,
  lastSignInTime: "",
};

const profile = (state = init, action = { type: "", payload: {} }) => {
  switch (action.type) {
    case RECEIVE_LOGIN:
      return {
        ...state,
        uid: action.payload.uid,
        displayName: action.payload.displayName,
        email: action.payload.email,
        date: action.payload.date,
        photoURL: action.payload.photoURL,
        isLogin: true,
        lastSignInTime: action.payload.lastSignInTime,
      };
    default:
      return state;
  }
};

export default profile;
